import { render } from "./AccessDenied.vue?vue&type=template&id=1f38f958&ts=true"
import script from "./AccessDenied.vue?vue&type=script&lang=ts"
export * from "./AccessDenied.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__